import * as React from 'react';
import { inject, observer } from 'mobx-react';
import styled from 'styled-components';
import { colors } from 'kaizen-ui-colors/lib';
import { IStore } from '../../domain/store/IStore';
import Card from './base/Card';
import { RoundMonitorProjectOverview } from './RoundMonitor/RoundMonitorProjectOverview';
import { RoundMonitorRoundOverview } from './RoundMonitor/RoundMonitorRoundOverview';
import { RoundMonitorVariationList } from './RoundMonitor/RoundMonitorVariationList';

interface IProps {
  store?: IStore;
}

const Layout = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 1fr;
  grid-template-rows: auto auto 1fr;
  grid-template-areas: 'project' 'round' 'variations';

  @media (min-width: 768px) {
    display: grid;
    width: 100%;
    grid-template-columns: 400px 1fr;
    grid-template-rows: auto 1fr;
    grid-template-areas: 'project variations' 'round variations';
  }
`;

const AreaProjectOverview = styled.div`
  grid-area: project;
  border-bottom: 1px solid ${colors.mochi_dark__ebedef};
`;

const AreaRoundOverview = styled.div`
  grid-area: round;
  border-bottom: 1px solid ${colors.mochi_dark__ebedef};

  @media (min-width: 768px) {
    border-bottom: 0;
  }
`;

const AreaVariations = styled.div`
  grid-area: variations;
  overflow: hidden;

  @media (min-width: 768px) {
    border-left: 1px solid ${colors.mochi_dark__ebedef};
  }
`;

@inject('store')
@observer
export class RoundMonitor extends React.Component<IProps, {}> {
  private store: IStore;

  constructor(props: IProps) {
    super(props);
    this.store = props.store!;
  }

  public render() {
    const { projectStore } = this.store;
    return (
      <React.Fragment>
        {projectStore.projects.map(project => (
          <Card key={project.id}>
            <Layout>
              <AreaProjectOverview>
                <RoundMonitorProjectOverview project={project} />
              </AreaProjectOverview>
              <AreaRoundOverview>
                <RoundMonitorRoundOverview project={project} />
              </AreaRoundOverview>
              <AreaVariations>
                <RoundMonitorVariationList project={project} />
              </AreaVariations>
            </Layout>
          </Card>
        ))}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/presentation/component/RoundMonitor.tsx